import { requisitionConfirmationAddressesStyles } from "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationAddresses";
import { css } from "styled-components";

const headerStyle = css`
    padding-top: 10px;
    font-size: 20px;
    line-height: 22px;
    margin-bottom: 12px;
`;

requisitionConfirmationAddressesStyles.billingAddressTitle = {
    variant: "h3",
    css: headerStyle,
};

requisitionConfirmationAddressesStyles.shippingAddressTitle = {
    variant: "h3",
    css: headerStyle,
};
